import React from 'react';
import { AssuranceIcon } from 'images';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import {
  CardRecap,
  ContentLeft,
  ContentRight,
  IconModify,
  PrimaryTitleCard,
} from './styles';

type CardRecapComponentProps = {
  content: JSX.Element;
  title: string;
  action: (event: React.MouseEvent<HTMLElement>) => void;
};
const CardRecapComponent = ({
  content,
  title,
  action,
}: CardRecapComponentProps) => {
  const lang = useSelector(getLocaleSelector);
  return (
    <CardRecap>
      <div style={{ padding: '8px' }}>
        <ContentLeft
          style={{ float: lang === LANGUAGES.AR ? 'right' : 'left' }}
          width="200px"
        >
          <PrimaryTitleCard>{title}</PrimaryTitleCard>
        </ContentLeft>
        <ContentRight
          style={{ float: lang === LANGUAGES.AR ? 'left' : 'right' }}
        >
          <IconModify
            style={{ height: 20, width: 20 }}
            onClick={action}
            src={AssuranceIcon.modifyIcon}
            alt={`modify Process - ${title}`}
          />
        </ContentRight>
        <div style={{ marginTop: 36 }}>{content}</div>
      </div>
    </CardRecap>
  );
};
export default CardRecapComponent;
